module.exports = __webpack_public_path__ + "static/img/062日式料理菜单.4cac134.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/062日式料理菜单.jpg
// module id = NdiH
// module chunks = 0